"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _Text = _interopRequireDefault(require("../Text"));

var _Image = _interopRequireDefault(require("../Image"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Styles = _reactNative.StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    height: 110,
    backgroundColor: 'white',
    borderRadius: 8,
    padding: 8
  },
  image: {
    width: 96,
    height: 96
  },
  imagePlaceholder: {
    backgroundColor: 'rgba(0,0,0,0.3)'
  },
  info: {
    flex: 1,
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingHorizontal: 10
  },
  name: {
    fontSize: 18,
    fontWeight: '700',
    color: 'rgba(33, 33, 33, 1)'
  },
  action: {
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

var _default = function _default(_ref) {
  var product = _ref.product,
      onPress = _ref.onPress,
      ActionComponent = _ref.ActionComponent,
      renderAction = _ref.renderAction,
      style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    onPress: onPress ? function () {
      return onPress(product);
    } : function () {},
    activeOpacity: onPress ? 0.2 : 1,
    style: [Styles.container, style]
  }, product.photo && /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    media: product.photo,
    style: Styles.image
  }), !product.photo && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [Styles.image, Styles.imagePlaceholder]
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: Styles.info
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: Styles.name,
    bold: true
  }, product.name)), ActionComponent && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: Styles.action
  }, /*#__PURE__*/_react["default"].createElement(ActionComponent, {
    product: product
  })), renderAction && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: Styles.action
  }, renderAction(product)));
};

exports["default"] = _default;